export const PcnListingType = Object.freeze({
    OPEN: "open",
    CLOSED:   "closed",
    ONHOLD:  "holding"
  });